import { ProgressSpinner } from "primereact/progressspinner";
import React from "react";
import { useGlobalContext } from "../../shared/GlobalContext";

export function SpinnerComponent() {
  const { loadingUrls } = useGlobalContext();

  return (
    <>
      {loadingUrls.length > 0 && (
        <div className="spinner-bg">
          <ProgressSpinner className="pointer-events-none spinner-container" aria-label="Loading" />
        </div>
      )}
    </>
  );
}
